import React, {
  useState,
  useEffect,
  useRef,
  forwardRef,
  useImperativeHandle,
} from "react";
import "./Tabs.css";
import { GoGear } from "react-icons/go";

const Tabs = forwardRef(({ children, onSelected, onLogOut }, ref) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [selectedItemText, setSelectedItemText] = useState("");
  const tabsRef = useRef();

  const handleTabClick = (index) => {
    setSelectedIndex(index);
    setSelectedItemText(menuItems[0].props.children[index].props.children);
    if (onSelected) {
      onSelected({ args: { item: index } });
    }
  };

  useEffect(() => {
    handleTabClick(0);
  }, []);

  useImperativeHandle(ref, () => ({
    getTitleAt: (index) => menuItems[0].props.children[index].props.children,
    getSelectedIndex: () => selectedIndex,
  }));

  const menuItems = React.Children.toArray(children).filter(
    (child) => child.type === "ul"
  );
  const contentItems = React.Children.toArray(children).filter(
    (child) => child.type !== "ul"
  );

  return (
    <div className="tab-root" ref={tabsRef}>
      <div className="tab-menu">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "auto",
            height: "100%",
            backgroundColor: "#4A5863",
            borderRadius: "14px 0px 0px 14px",
          }}
        >
          <div
            style={{
              padding: "16px 6px",
              fontSize: "15px",
              color: "rgb(95, 207, 214)",
              fontWeight: "900",
              textAlign: "center",
              backgroundColor: "rgb(55,65,74)",
              borderRadius: "14px 0px 0px 0px",
              // textShadow: `
              //   1px 1px 0 rgb(95, 207, 214),
              //   -1px -1px 0 rgb(95, 207, 214),
              //   1px -1px 0 rgb(95, 207, 214),
              //   -1px 1px 0 rgb(95, 207, 214)
              // `,
              letterSpacing: "0px",
            }}
          >
            (주)동명스틸
          </div>
          {menuItems.length > 0 && (
            <>
              {menuItems[0].props.children.map((child, index) => (
                <div
                  key={index}
                  className="tabs-menu-item"
                  onClick={() => handleTabClick(index)}
                  style={{
                    backgroundColor:
                      selectedIndex === index ? "rgb(100, 194, 206)" : "",
                    textAlign: "center",
                  }}
                >
                  <div>
                    <img
                      src={
                        selectedIndex === index
                          ? child.props.selectedImageurl
                          : child.props.imageurl
                      }
                      alt={`${child.props.imageurl}`}
                      style={{
                        maxHeight: "28px",
                        textAlign: "center",
                        margin: "3px 0px 2px 0px",
                      }}
                    />
                  </div>
                  <span style={{ whiteSpace: "nowrap", color: "white" }}>
                    {child}
                  </span>
                </div>
              ))}
            </>
          )}
        </div>
      </div>

      <div className="tab-body">
        <div style={{ display: "flex" }}>
          <div className="tab-title">{selectedItemText}</div>
          <div
            style={{
              marginLeft: "auto",
              marginRight: "6px",
              boxSizing: "border-box",
            }}
          >
            <div
              style={{
                display: "flex",
                position: "relative",
                top: "55%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                padding: "4px",
                boxSizing: "border-box",
                alignItems: "center",
              }}
            >
              <div style={{ color: "rgb(66,66,66)" }}>
                {window.sessionStorage.getItem("workplace_nm") ?? ""}{" "}
              </div>
              <div className="ms-4" style={{ color: "rgb(66,66,66)" }}>
                {window.sessionStorage.getItem("user_name") ?? ""}
              </div>
              <div className="d-btn accent ms-4" onClick={onLogOut}>
                로그아웃
              </div>
              {/* <GoGear
                style={{
                  width: "100%",
                  height: "100%",
                  color: "rgb(127,127,127)",
                }}
              /> */}
            </div>
          </div>
        </div>
        {contentItems.map((content, index) => (
          <div
            className="tab-content"
            key={index}
            style={{
              display: selectedIndex === index ? "block" : "none",
              height: "100%",
              boxSizing: "border-box",
            }}
          >
            {content}
          </div>
        ))}
      </div>
    </div>
  );
});

export default Tabs;
